import React from 'react';

function About() {
  return (
    <section id="about" className="about">
      <div className="about-container">
        <h2>About Conrad Tutoring</h2>
        <p>
          In response to recent changes in COVID-era grading policies that have made it harder for students to achieve an A, Conrad Tutoring was founded to meet the growing demand for high-quality, personalized tutoring services. Our mission is to help students excel academically, even as standards rise.
        </p>
        <div className="features">
          <div className="feature">
            <h3>📈 Building Credibility</h3>
            <p>We start by offering discounted or free sessions in exchange for honest testimonials. Our results are proven by tracking GPA and SAT/ACT score improvements, and we maintain a strong online presence for transparency and outreach.</p>
          </div>
          <div className="feature">
            <h3>🎯 Outperforming the Competition</h3>
            <p>We specialize in niche areas, such as AP tutoring for ESL students, and use targeted marketing (like TikTok ads) to reach students directly. Our placement tests allow us to personalize every session to address each student's unique needs.</p>
          </div>
          <div className="feature">
            <h3>⭐ Personalized, Data-Driven Tutoring</h3>
            <p>Every student receives a tailored learning plan based on placement test data, with regular progress tracking and grade monitoring to ensure measurable improvement.</p>
          </div>
          <div className="feature">
            <h3>💬 Proven Value & Retention</h3>
            <p>We offer rewards programs, including reduced rates for bulk hours and referral credits for families who recommend us. The first session is always free for new clients, making it easy to get started.</p>
          </div>
        </div>
        <div className="methodology">
          <h3>Our Methodology</h3>
          <ul>
            <li>Initial placement testing to identify each student's weak points</li>
            <li>Customized learning plans and one-on-one sessions</li>
            <li>Regular progress tracking and transparent reporting</li>
            <li>Flexible pricing: discounts for bulk hours, referral and rewards programs</li>
            <li>Strong online presence and community testimonials</li>
          </ul>
        </div>
        <div className="target-market">
          <h3>Who We Serve</h3>
          <p>
            Conrad Tutoring is dedicated to hardworking students in our county who are striving for academic excellence and have the drive and resources to succeed. We leverage years of tutoring expertise to provide a needed service in a changing educational landscape.
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;
